(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Menu", [], factory);
	else if(typeof exports === 'object')
		exports["Menu"] = factory();
	else
		root["Menu"] = factory();
})(this, function() {
return 